import * as S from "./style";
//Components
import InputSearch from "../../FieldSearch";
import ActionButton from "../../Button/ActionButton";
import PopMenu from "../../PopMenu";

import CreateLens from "../../Modals/Lens/Create";
import CreateAntiGlare from "../../Modals/AntiGlare/Create";
import CreateSurfacing from "../../../components/Modals/Surfacing/Create";
import CreateDiameter from "../../../components/Modals/Diameter/Create";
import CreateIndice from "../../../components/Modals/Indice/Create";
import CreateHeight from "../../../components/Modals/Height/Create";
import CreateLaboratory from "../../../components/Modals/Laboratory/Create";

import CreateTypeLens from "../../../components/Modals/TypeLens/Create";
import CreateSensitivity from "../../../components/Modals/Sensitivity/Create";

import Toast from "../../../components/Toast";
//Hooks
import { useMultipleModal } from "../../../hooks/useMultipleModal";
//Icons
import { CaretDown, Export } from "@phosphor-icons/react";
import { ITitle } from "Interfaces/ITitle";
import { useState } from "react";

export default function TitleMenu({
  title,
  subtitle,
  placeholderSearch,
  listPopMenu,
  listPopButton,
  fetchData,
  filterSearch,
  exportButton,
  visibleButton = true,
}: ITitle) {
  const { isOpenModal, toggleModalVisibility, assignRef } = useMultipleModal();
  const [toastData, setToastData] = useState({
    status: 200,
    message: "",
  });

  const handleInputChange = (inputSearch: string) => {
    filterSearch(inputSearch);
  };

  return (
    <S.Container>
      <S.Title>
        <S.H4>{title}</S.H4>
        <S.H6>{subtitle}</S.H6>
      </S.Title>

      <S.ContentSearch>
        <InputSearch name={placeholderSearch} onSearch={handleInputChange} />
        <ActionButton
          name="Exportar"
          Icon={<Export size={18} weight="bold" />}
          onClick={exportButton}
        />
        {visibleButton && (
          <S.ContentPopButton>
            <ActionButton
              name="Novo Produto"
              Icon={<CaretDown size={16} weight="fill" />}
              onClick={() => toggleModalVisibility("menu")}
            />
            {isOpenModal("menu") && (
              <div ref={(ref) => assignRef("menu", ref)}>
                <PopMenu
                  listName={listPopMenu}
                  onClickHandlers={listPopButton?.map((val) => {
                    return () => toggleModalVisibility(val);
                  })}
                />
              </div>
            )}
          </S.ContentPopButton>
        )}
      </S.ContentSearch>

      <CreateLens
        isOpenModal={isOpenModal("lens")}
        setModalClose={() => toggleModalVisibility("lens")}
        refreshFrames={fetchData}
        setToastOpen={() => toggleModalVisibility('open-toast')}
        setToastData={setToastData}
      />
      <CreateAntiGlare
        isOpenModalBraind={isOpenModal("anti-glare")}
        setModalClose={() => toggleModalVisibility("anti-glare")}
      />
      <CreateTypeLens
        isOpenModalBraind={isOpenModal("type-lens")}
        setModalClose={() => toggleModalVisibility("type-lens")}
        refreshFrames={fetchData}
      />
      <CreateSensitivity
        isOpenModalBraind={isOpenModal("sensitivity")}
        setModalClose={() => toggleModalVisibility("sensitivity")}
        refreshFrames={fetchData}
      />
      <CreateSurfacing
        isOpenModal={isOpenModal("surfacing")}
        setModalClose={() => toggleModalVisibility("surfacing")}
        refreshFrames={fetchData}
        setToastOpen={() => toggleModalVisibility('open-toast')}
        setToastData={setToastData}
      />
      <CreateDiameter
        isOpenModal={isOpenModal("diameter")}
        setModalClose={() => toggleModalVisibility("diameter")}
        refreshFrames={fetchData}
        setToastOpen={() => toggleModalVisibility('open-toast')}
        setToastData={setToastData}
      />
      <CreateIndice
        isOpenModal={isOpenModal("index")}
        setModalClose={() => toggleModalVisibility("index")}
        refreshFrames={fetchData}
        setToastOpen={() => toggleModalVisibility('open-toast')}
        setToastData={setToastData}
      />
      <CreateHeight
        isOpenModal={isOpenModal("height")}
        setModalClose={() => toggleModalVisibility("height")}
        refreshFrames={fetchData}
        setToastOpen={() => toggleModalVisibility('open-toast')}
        setToastData={setToastData}
      />
      <CreateLaboratory
        isOpenModal={isOpenModal("laboratory")}
        setModalClose={() => toggleModalVisibility("laboratory")}
        refreshFrames={fetchData}
        setToastOpen={() => toggleModalVisibility('open-toast')}
        setToastData={setToastData}
      />
      <Toast
        openToast={isOpenModal('open-toast')}
        closeToast={() => toggleModalVisibility('open-toast')}
        message={toastData.message}
        status={toastData.status}
      />
    </S.Container>
  );
}
